/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon20Regular = forwardRef('ArrowParallelVIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.18 7.894a.75.75 0 0 1-1.06-1.061L4.393 3.56c.75-.75 1.967-.75 2.718 0l3.273 3.273a.75.75 0 0 1-1.06 1.06l-2.822-2.82V16.25a.75.75 0 1 1-1.5 0V5.072L2.18 7.894Z" }),
        React.createElement("path", { d: "M15 14.928V3.75a.75.75 0 0 0-1.5 0v11.178l-2.82-2.822a.75.75 0 1 0-1.062 1.061l3.273 3.273c.75.75 1.968.75 2.718 0l3.273-3.273a.75.75 0 0 0-1.06-1.06L15 14.926Z" })));
});
